import { useState, useContext } from "react";
import { withApollo } from "react-apollo";
import { APPROVE_BOOKING } from "../../gql/bookingapi/mutations";
import ConfirmDialog from "../../components/shared/ConfirmDialog";
import { PaginationContext } from "../../components/shared/pagination/PaginationContext";

const handleRejectBookingFactory = ({
  client,
  booking,
  user,
  rejectionReason,
  setIsProcessing,
  dispatchAction,
  setOpenRejectDialog,
  setRejectionReason,
}) => {
  return async () => {
    if (!booking?.id || !rejectionReason.trim()) {
      return;
    }

    try {
      setIsProcessing(true);
      dispatchAction({
        type: "fetching",
        payload: true,
      });

      await client.mutate({
        mutation: APPROVE_BOOKING,
        variables: {
          bookingId: booking.id,
          approval: {
            status: "REJECTED",
            approvedBy: user.user,
            approvedByEmail: user.email,
            rejectionReason: rejectionReason.trim(),
          },
          createdBy: user.user,
          createdByEmail: user.email,
        },
      });

      setOpenRejectDialog(false);
      setRejectionReason("");
    } catch (error) {
      setIsProcessing(false);
      dispatchAction({
        type: "clearAll",
      });
    }
  };
};

const HazardousRejectDialog = ({
  client,
  openRejectDialog = false,
  setOpenRejectDialog,
  booking,
  user,
  status,
  setStatus,
}) => {
  const { dispatchAction } = useContext(PaginationContext);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleRejectBooking = handleRejectBookingFactory({
    client,
    booking,
    user,
    rejectionReason,
    setIsProcessing: setStatus || setIsProcessing,
    dispatchAction,
    setOpenRejectDialog,
    setRejectionReason,
  });

  const handleOnClose = () => {
    setOpenRejectDialog(false);
    setRejectionReason("");
    return true;
  };

  const handleOnReject = async () => {
    await handleRejectBooking();
  };

  const handleOnCancel = () => {
    setOpenRejectDialog(false);
    setRejectionReason("");
  };

  const handleReasonChange = (reason) => {
    setRejectionReason(reason);
  };

  return (
    <ConfirmDialog
      open={openRejectDialog}
      close={handleOnClose}
      onCancel={handleOnCancel}
      onApprove={handleOnReject}
      title="Reject Booking"
      approveText="Confirm Rejection"
      approveColor="error"
      approveVariant="contained"
      cancelText="Cancel"
      cancelVariant="outlined"
      cancelColor="primary"
      loading={status || isProcessing}
      disableBooking={!rejectionReason}
      fullWidth={false}
      maxWidth="sm"
      data-testid="hazardous-reject-dialog"
      content='Please provide a reason for rejecting this booking:'
      showReasonDD={true}
      reasonValue={rejectionReason}
      onReasonChanged={handleReasonChange}
    >
    </ConfirmDialog>
  );
};

export default withApollo(HazardousRejectDialog);
